// we can use this import to bring in all of the components from the React library.
// That is why we can the React in React.FC<CountTimerProps
import * as React from 'react';
import { Typography } from '@mui/material';

// The interface usage comes from Typescript. The props that come into here are coming from somewhere else. Like props being passed into the component in zone.util.tsx.
interface CountTimerProps {
  endTime: Date;
}

// When creating a function component we can write it this way. The props are coming from the interface.
export const CountdownTimer: React.FC<CountTimerProps> = (props) => {
  // We set up state. For time remaining, we will put the hours, minutes, and seconds inside an object.
  const [timeRemaining, setTimeRemaining] = React.useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });
  // Here we apply object destructuring. This is coming from the interface props
  const { endTime } = props;
  // We need a function to calculate the time left of the timer.
  const calculateTimeLeft = () => {
    // Instantiate a variable new Date
    const today = new Date();

    // milliseconds between now and endTime
    const difference = endTime.valueOf() - today.valueOf();

    // convert millisecond difference into hours, minutes, seconds
    const timeDiff = {
      days: difference > 0 ? Math.floor(difference / (1000 * 60 * 60) / 24) : 0,
      hours: difference > 0 ? Math.floor((difference / (1000 * 60 * 60)) % 24) : 0,
      minutes: difference > 0 ? Math.floor((difference / 1000 / 60) % 60) : 0,
      seconds: difference > 0 ? Math.floor((difference / 1000) % 60) : 0,
    };

    // After defining the time difference, we setTimeRemaining state with timeDiff as the argument.
    setTimeRemaining(timeDiff);
  };

  // create the useEffect.
  React.useEffect(() => {
    // Set up interval logic. The interval variable will serve as our interval ID to which we use to refer to clear interval.
    // We setInterval with the argument calculateTimeLeft function, and the amount of milliseconds for which the component will render.
    const interval = setInterval(calculateTimeLeft, 1000);
    // Return the function clearInterval with the interval variable as the argument. Remember the variable interval is an "id".
    return () => clearInterval(interval);
  });

  // This function is used so that the countdown displayed will have a format like this: 00:00:00
  const pad = (value: number): string => {
    return value.toString().padStart(2, '0');
  };

  return (
    // We then apply the pad function to the JSX element we want to show...hours, minutes, seconds!
    <Typography>
      {timeRemaining.days > 0 ? `${timeRemaining.days}d ` : ''}
      {pad(timeRemaining.hours)}:{pad(timeRemaining.minutes)}:{pad(timeRemaining.seconds)}
    </Typography>
  );
};
